import { Box, Icon, SxProps } from "@outschool/backpack";
import { faSpinner } from "@outschool/icons";
import React, { useEffect, useState } from "react";

export interface LoadingProps {
  /** Delay in milliseconds before the loader will show. */
  delay?: number;
  /** Expands the container around the spinner to 100vh. */
  fullHeight?: boolean;
  sx?: SxProps;
  iconSx?: SxProps;
  [prop: string]: any;
}

/**
 * A basic loading spinner.
 */
const Loading: React.FC<LoadingProps> = ({
  delay = 300,
  fullHeight = false,
  sx,
  iconSx,
  ...rest
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    if (delay !== undefined) {
      timeoutId = setTimeout(() => setShow(true), delay);
    }
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      // @ts-ignore
      sx={[
        {
          color: "#AAA",
          textAlign: "center",
          marginY: "3em",
          ...(fullHeight && {
            height: "100vh",
          }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {show && (
        // @ts-ignore
        <Icon
          icon={faSpinner}
          fixedWidth
          spin
          sx={[
            {
              fontSize: "3em",
            },
            ...(Array.isArray(iconSx) ? iconSx : [iconSx]),
          ]}
        />
      )}
    </Box>
  );
};

export const LoadingModal = () => <Loading sx={{ flexGrow: 1 }} />;

export const LoadingInline = () => <Loading sx={{ marginY: "1em" }} />;

export default Loading;
